import * as React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from '../../css/pc/PcGeneral.module.css';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);
const imgPath = process.env.REACT_APP_S3_IMG_PATH;

export default function SamsungPayHeader(props) {
  const {t} = useTranslation();

  SamsungPayHeader.propTypes = {
    headerMessage: PropTypes.string
  };

  return (
    <div className={cx('mpi-boxtop')}>
      <h1 className={cx('mpi-title')}>
        <img src={`${imgPath}/Logo_pay.png`} alt="samsungpay"/>
      </h1>
      <p className={cx('mpi-titletext')}>{t(props.headerMessage)}</p>
    </div>
  );
}